namespace Solovis.Reports.Parameters {

  type SavedTag = { tagId: number, tagSetId: number, tagLabel: string, tagSetLabel: string };
  type SaveTagCallback = (tag: SavedTag) => void;

  export class AddTagDialog {

    private _dialogWindow: Solovis.UI.Dialog;
    private _labelInput: JQuery;
    private _codeInput: JQuery;
    private _portalServices: Solovis.Portal.IPortalServices;
    private _tagSetId: number;
    private _saveCallback: SaveTagCallback;

    constructor({ tagSetId, portalServices, saveCallback }: {
      tagSetId: number,
      portalServices: Solovis.Portal.IPortalServices,
      saveCallback: SaveTagCallback
    }) {
      const self = this;

      this._tagSetId = tagSetId;
      this._portalServices = portalServices;
      this._saveCallback = saveCallback;

      const contentDiv = $("<div>");

      const formTable = $("<table>").css({ "border-spacing": "8px", "border-collapse": "separate" }).appendTo(contentDiv);

      const labelRow = $("<tr>").appendTo(formTable);
      $("<td>").text("Label").css("text-align", "right").appendTo(labelRow);
      this._labelInput = $("<input>").attr("type", "text").css("width", "300px").appendTo($("<td>").appendTo(labelRow));

      const codeRow = $("<tr>").appendTo(formTable);
      $("<td>").text("Code").css("text-align", "right").appendTo(codeRow);
      this._codeInput = $("<input>").attr("type", "text").css("width", "300px").appendTo($("<td>").appendTo(codeRow));

      this._portalServices.rpc().invoke("~/DataManagement/TagSetEditor/GetAddTagSetDialogInitialState", null)
        .then(response => {
          this._codeInput.val(response.result.code);
        });

      this._dialogWindow = new Solovis.UI.Dialog({
        container: contentDiv,
        title: "Add Tag",
        modal: true,
        center: true,
        autoOpen: true,
        destroyOnClose: true,
        width: 460,
        minWidth: 300,
        buttons: [
          {
            label: "Save",
            click: function () {
              self._save();
            }
          },
          {
            label: "Cancel",
            click: function () {
              self._dialogWindow.close();
            }
          }
        ],
        activate: function () {
          self._labelInput.focus();
        }
      });
    }

    private async _save() {
      const label = (this._labelInput.val() as string).trim();
      if (!label) {
        Solovis.UI.alert("Please enter a label.");
        this._labelInput.focus();
        return;
      }

      const code = (this._codeInput.val() as string).trim() || null;

      try {
        const response = await this._portalServices.rpc().invoke(
          "~/Rpc/TagSetEdit/AddTopLevelTag",
          { tagSetId: this._tagSetId, label: label, code: code }
        );
        const result = response.result;
        this._saveCallback({
          tagId: result.tagId,
          tagSetId: result.tagSetId,
          tagLabel: result.tagLabel,
          tagSetLabel: result.tagSetLabel,
        });
        this._dialogWindow.close();
      } catch (error) {
        Solovis.UI.alert(error.message || "Failed to add tag.");
      }
    }
  }
}